import { render } from "./RiProdcategory04.vue?vue&type=template&id=07a4d6a6"
import script from "./RiProdcategory04.vue?vue&type=script&lang=js"
export * from "./RiProdcategory04.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiProdcategory04.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "07a4d6a6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('07a4d6a6', __exports__)) {
    api.reload('07a4d6a6', __exports__)
  }
  
  module.hot.accept("./RiProdcategory04.vue?vue&type=template&id=07a4d6a6", () => {
    api.rerender('07a4d6a6', render)
  })

}


export default __exports__